import React from "react";
import { View, ScrollView, Text } from "react-native";

import {
  getElementModel,
  isWeb,
  navigate,
} from "../../../helpers/utils";
import Footer from "../common/footer";
import HomePageHeader from "./HomePageHeader";
import GatedProduct from "./gated-product";
import JournalTimePicker from "../journal/JournalTimePicker";
import appStyles from "../../appStyles";
import HomeFabButton from "./HomeFabButton";
import TutorialsHomeCard from "./gated-product/TutorialsHomeCard";

import TUTORIALS_DATA from "../tutorials/data";
import TutorialsHelper from "../tutorials/TutorialsHelper";
import JournalDialog from "../common/JournalDialog";
import HomeCard from "./cards/HomeCard";
import MenuEditOptionsPanel from "../common/MenuEditOptionsPanel";
import MultipleElements from "../journal/multiple/MultipleElements";
import CardItems, { buildCards } from "../cards/CardItems";
import SnoozeOptions from "../common/SnoozeOptions";
import appPages from "../../../appPages";
import ElementsHelper from "../elements/ElementsHelper";
import NotificationsHelper from "../../../helpers/notifications/NotificationsHelper";
import SettingsHelper from "../more/SettingsHelper";
import TimerCard from './cards/timer/TimerCard';

export default class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
    this.minutesInterval = props.controller.state?.settings?.interval_duration;
    this.homeCard = null;

    this.state = {
      currentTimePickerSlot: null,
      journalTimeslot: null,
      expandedSlots: [],
      snoozedCardProxy: null,
      snoozeY: null,
    };
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          this.componentDidFocus();
        },
      );
    }

    this.controller.registerRefresh(() => {
      this.refreshContent();
    });

    if (
      this.controller.state.settings == null ||
      this.controller.hasNavigation()
    ) {
      this.controller.getItems();
    }
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  componentDidUpdate = async () => {
    this.initTutorials();

    const needsRefresh = await this.needsStateRefresh();
    if (needsRefresh) {
      this.componentDidFocus();
    }
  };

  needsStateRefresh = async () => {
    const timeslots = this.controller.state.timeslots;
    const currentUser =
      this.controller.state.impersonate || this.controller.state.currentUser;
    const termsAgreed =
      this.controller.state.settings != null &&
      this.controller.state.settings.terms_agreed;

    if (
      this.state.currentUser !== currentUser &&
      this.controller.state.impersonate == null
    ) {
      if (
        this.controller.state.currentUser &&
        (this.controller.state.impersonate == null ||
          this.controller.state.impersonate ==
            this.controller.state.currentUser)
      ) {
        this.setState((state) => ({
          ...state,
          currentUser,
          timeslots,
        }));

        if (!termsAgreed && this.controller.hasNavigation()) {
          const navigation = this.props.navigation;
          this.controller.cardActionWithCallback(
            {
              action: "check",
              element: "terms",
            },
            (data, response) => {
              if (0 == response.id) navigation.navigate("terms");
            },
            (error) => {},
          );
        } else if (!timeslots) this.controller.getItems();
      }

      return true;
    } else {
      return false;
    }
  };

  componentDidFocus = async () => {
    // Check if calendars are enabled to trigger notifications
    NotificationsHelper.showNoCalendarsNotification(this.controller);

    const { force_onboarding } =
      this.controller.state?.settings?.testing_preferences || {};
    if (force_onboarding) {
      this.redirectOnboarding();
    } else {
      this.setState((state) => ({ ...state, showManaMindful: false }));
      this.refreshContent();
    }
  };

  redirectOnboarding() {
    const action = {
      action: "save",
      target: "testing",
      force_onboarding: false,
    };
    this.controller.apiService.cardAction(action).then((c) => {
      this.controller.getItems();
    });

    navigate(this.controller, appPages.integrationsOnboarding, "changePage", {
      isFromCard: false,
      step: 0,
    });
  }

  refreshContent = () => {
    if (this.homeCard?.refresh) {
      this.homeCard?.refresh();
    } else {
      this.controller.getItems();
    }
  };

  snoozeCard = (cardUtils, e) => {
    const y = e.clientY || e.nativeEvent?.pageY;
    this.setState((state) => ({
      ...state,
      snoozedCardProxy: cardUtils,
      snoozeY: y,
    }));
  };

  // ------------------------------------- MARI -------------------------------------
  updateMariMessage = (mariMessage) => {
    this.setState((state) => ({ ...state, mariMessage }));
  };

  showManaMindFul = () => {
    this.setState((state) => ({ ...state, showManaMindful: true }));

    setTimeout(() => {
      this.setState((state) => ({
        ...state,
        showManaMindful: false,
      }));
    }, 5000);
  };

  // ------------------------------------- TUTORIALS -------------------------------------
  initTutorials = () => {
    const keys = TutorialsHelper.STORAGE_KEYS;
    const showTutorials = this.controller?.state?.showTutorials || {};
    const showReflectionTutorials = showTutorials[keys.reflection];
    const showGoalTutorials = showTutorials[keys.goals];

    if (showReflectionTutorials != this.state.showReflectionTutorials) {
      this.setState((state) => ({
        ...state,
        showReflectionTutorials,
        mariMessage: "",
        mariAction: {},
        tutorialStep: -1,
      }));
    } else if (showGoalTutorials != this.state.showGoalTutorials) {
      const tutorial = showGoalTutorials ? TUTORIALS_DATA["home"][1] : {};

      this.setState(
        (state) => ({
          ...state,
          showGoalTutorials,
          mariMessage: tutorial.message,
          mariAction: "",
        }),
        () => {
          if (showGoalTutorials) {
            this.controller.setState({ focusedTab: "goals" });
          }
        },
      );
    }
  };

  initReflectionTutorial = () => {
    const tutorial = TUTORIALS_DATA["home"][0];

    this.setState((state) => ({
      ...state,
      mariMessage: tutorial.message,
      tutorialStep: 1,
      mariAction: {
        text: tutorial.action.text,
        onPress: () => {
          this.setState(
            (s) => ({
              ...s,
              tutorialStep: -1,
              mariMessage: "",
              mariAction: "",
            }),
            this.controller.changePage("rn:onboarding_template", {}),
          );
        },
      },
    }));
  };

  // ------------------------------------- MENU -------------------------------------
  getMenuOptions = (timeslot) => {
    let options = [
      {
        text: "Edit Timeslot Details",
        action: () => this.onMenuAction("edit"),
      },
      {
        text: "Change Start and/or End-Time",
        action: () => this.onMenuAction("time"),
      },
      {
        action: () => this.onMenuAction("notes"),
        text: (timeslot?.note ? "Edit" : "Add") + " Journal Entry",
      },
    ];

    if (timeslot.activity != null) {
      options.push({
        text: "Edit Element",
        action: () => this.onMenuAction("edit_element"),
      });
      options.push({
        action: () => this.onMenuAction("multiple"),
        text: "Track with Another Element",
      });
    }

    if (timeslot.undo_activity) {
      options.push({
        text: "Remove Activity from Timeslot",
        isDelete: true,
        action: () => this.onMenuAction("remove"),
      });
    }

    return options;
  };

  toggleEditMenuOptions = (ts) => {
    this.setState((state) => ({
      ...state,
      selectedMenuTimeslot: ts,
    }));
  };

  goToEditElementPage = (element) => {
    const elementData = ElementsHelper.findById(this.controller, element.id);
    if (elementData) {
      navigate(this.controller, "rn:edit_element", "changepage", {
        element: getElementModel(elementData),
      });
    }
  };

  goToEditPage = (timeslot, params = {}) => {
    navigate(this.controller, appPages.trackDetail, "changePage", {
      timeslot,
      ...params,
      sourceUrl: "rn:home_card",
      returnUrl: "rn:home_card",
    });
  };

  toggleJournalDialog = (timeslot) => {
    this.setState((state) => ({
      ...state,
      journalTimeslot: timeslot,
      selectedMenuTimeslot: null,
      multipleElementsTimeslot: null,
    }));
  };

  toggleGoalJournalDialog = (goal, cb) => {
    this.setState((state) => ({
      ...state,
      selectedGoal: goal,
      onGoalJournalComplete: cb,
    }));
  };

  toggleTimePickerDialog = (timeslot) => {
    this.setState((state) => ({ ...state, currentTimePickerSlot: timeslot }));
  };

  closeTimePicker = () => {
    this.setState((state) => ({
      ...state,
      currentTimePickerSlot: null,
      mariMessage: "",
    }));
  };

  toggleMultipleElementsDialog = (timeslot) => {
    this.setState((state) => ({
      ...state,
      journalTimeslot: null,
      selectedMenuTimeslot: null,
      multipleElementsTimeslot: timeslot,
    }));

    this.refreshContent();
  };

  removeActivity = (timeslot) => {
    const updatedTimeslot = {
      ...timeslot,
      activity: {
        id: "-",
      },
      user_confirmed: true,
      hidePredictions: true,
      source: "edit",
    };

    if (this.homeCard) {
      this.homeCard.confirmTimeslot({ timeslot: updatedTimeslot });
    }
  };

  undoActivity = (timeslot) => {
    const updatedTimeslot = {
      ...timeslot,
      activity: {
        ...timeslot.activity,
        id: timeslot.undo_activity,
      },
      user_confirmed: true,
      hidePredictions: true,
      source: "edit",
    };

    if (this.homeCard) {
      this.homeCard.confirmTimeslot({ timeslot: updatedTimeslot });
    }
  };

  onMenuAction = (actionType = "edit") => {
    const { selectedMenuTimeslot } = this.state;
    if (!selectedMenuTimeslot) return;

    this.setState((state) => ({ ...state, selectedMenuTimeslot: null }));

    switch (actionType) {
      case "edit":
        this.goToEditPage(selectedMenuTimeslot);
        break;
      case "edit_element":
        this.goToEditElementPage(selectedMenuTimeslot.activity);
        break;
      case "time":
        this.toggleTimePickerDialog(selectedMenuTimeslot);
        break;
      case "notes":
        this.toggleJournalDialog(selectedMenuTimeslot);
        break;
      case "multiple":
        //this.toggleMultipleElementsDialog(selectedMenuTimeslot);
        this.goToEditPage(selectedMenuTimeslot, { multiple: true });
        break;
      case "remove":
        this.removeActivity(selectedMenuTimeslot);
        break;
      case "undo":
        this.undoActivity(selectedMenuTimeslot);
        break;
      default:
        break;
    }
  };

  viewSnoozedCards = () => {
    const navigation = this.props.navigation;
    navigation.navigate("snoozed_cards");
  };

  goToChatRoom = () => {
    const navigation = this.props.navigation;
    navigation.navigate("coaching_room");
  };


  startTimer = () => {
    SettingsHelper.toggleTimerCardPreferences(this.controller, true);
  }

  // ------------------------------------- RENDER -------------------------------------
  render() {
    const termsAgreed =
      this.controller.state.settings != null &&
      this.controller.state.settings.terms_agreed;
    /*  const tutorialDone =
      this.controller.state.settings != null &&
      this.controller.state.settings.tutorial_done; */
    const showUI =
      termsAgreed /* && tutorialDone //2020.10 - removed tutorial done check*/ ||
      this.controller.state.impersonate != null;
    const showGated =
      this.controller != null &&
      this.controller.state.settings != null &&
      !this.controller.state.settings.is_enabled;

    const cardsV2 = [
      <TimerCard controller={this.controller} key={"showTimerCard"} />,
      /*
      <AutoTrackMappingCard
        controller={this.controller}
        key={"autotrackCard"}
        onSnooze={this.snoozeCard}
        {...this.props}
      />,
       */
    ];

    const snoozedCards = this.controller.state.snoozed_cards || [];
    const cardItems = this.controller.state.cards_v2 || [];
    const filteredCards = [];
    cardItems.forEach((c) => {
      if (!snoozedCards[c.card_id]) filteredCards.push(c);
    }); 

    // 2022.01.14 Moved to CardItems. Desktop card on position 1
    CardItems.addReconnectCard(this.controller, cardsV2, "desktop");

    buildCards(this.controller, filteredCards, cardsV2, {
      showManaMindful: this.showManaMindFul,
      onSnooze: this.snoozeCard,
      toggleGoalJournalDialog: this.toggleGoalJournalDialog,
      isHomePage: true,
    });

    CardItems.addReconnectCards(this.controller, cardsV2);

    const hasNavigation =
      this.controller.hasNavigation() && this.controller.navigation;
    const {
      currentTimePickerSlot,
      journalTimeslot,
      showReflectionTutorials,
      showGoalTutorials,
      tutorialStep,
      mariAction,
      showTutorials,
      selectedMenuTimeslot,
      multipleElementsTimeslot,
      snoozedCardProxy,
      snoozeY,
      selectedGoal,
    } = this.state;

    const { show_home_card } = this.controller.state?.settings || {};

    return multipleElementsTimeslot ? (
      <MultipleElements
        timeslot={multipleElementsTimeslot}
        controller={this.controller}
        goBack={() => this.toggleMultipleElementsDialog()}
      />
    ) : (
      <View
        style={
          this.controller.hasNavigation() && !isWeb
            ? appStyles.containerNavigation
            : appStyles.container
        }
      >
        {/* Header */}
        {showUI ? (
          <HomePageHeader
            controller={this.controller}
            onAvatarClick={this.refreshContent}
          />
        ) : null}

        <TutorialsHomeCard
          isOpen={showReflectionTutorials && tutorialStep < 0}
          controller={this.controller}
          loadTutorial={this.initReflectionTutorial}
        />

        <ScrollView
          style={{ marginBottom: hasNavigation ? 0 : 75 }}
          ref={(r) => {
            if (r != null) r.scrollTo({ y: 0, animated: false });
          }}
        >
          {showGated ? (
            <>
              {showUI ? <GatedProduct controller={this.controller} /> : null}

              <Text> </Text>
              <Text> </Text>
            </>
          ) : (
            <>
              {showUI && show_home_card ? (
                <HomeCard
                  ref={(c) => {
                    this.homeCard = c;
                  }}
                  controller={this.controller}
                  navigation={this.props.navigation}
                  toggleJournalDialog={this.toggleJournalDialog}
                  toggleTimePickerDialog={this.toggleTimePickerDialog}
                  currentTimePickerSlot={currentTimePickerSlot}
                  expandedSlots={this.state.expandedSlots}
                  goToEditPage={this.goToEditPage}
                  openMenuOptions={this.toggleEditMenuOptions}
                />
              ) : null}

              {showUI ? cardsV2 : null}

              <Text style={{ marginBottom: 250 }}> </Text>
            </>
          )}
        </ScrollView>
        {showUI ? (
          this.controller.hasNavigation() ? null : (
            <View style={appStyles.footerOptions}>
              <Footer
                controller={this.controller}
                selectedPage="home_card"
                highlightPage={tutorialStep == 1 ? "resolution" : ""}
              />
            </View>
          )
        ) : null}

        {showUI ? (
          <HomeFabButton
            style={{ bottom: isWeb ? 50 : 0 }}
            showManaMindful={this.state.showManaMindful}
            viewSnoozedCards={this.viewSnoozedCards}
            refresh={this.refreshContent}
            startTimer={this.startTimer}
            goToChatRoom={this.goToChatRoom}
            mariOptions={{
              mariMessage: this.state.mariMessage,
              mariAction,
              showTutorials,
              hideActions: showReflectionTutorials || showGoalTutorials,
              showOverlay:
                (showReflectionTutorials && tutorialStep >= 0) ||
                showGoalTutorials,
            }}
          />
        ) : null}

        {snoozedCardProxy ? (
          <SnoozeOptions
            style={{ marginBottom: 16 }}
            showSnoozed={false}
            snoozeY={snoozeY}
            onSnooze={(option) => {
              snoozedCardProxy.snoozeCard(option);
              this.setState((state) => ({
                ...state,
                snoozedCardProxy: null,
              }));
            }}
          />
        ) : null}

        {/* Time picker */}
        <JournalTimePicker
          controller={this.controller}
          timeslot={currentTimePickerSlot}
          minutesInterval={this.minutesInterval}
          onClose={this.closeTimePicker}
          toggleTimePicker={this.toggleTimePickerDialog}
          allTimeslots={this.controller.state.timeslots}
          updateMariMessage={this.updateMariMessage}
        />

        {/* Journal */}
        {journalTimeslot && journalTimeslot.id ? (
          <JournalDialog
            type={"timeslot"}
            item={journalTimeslot}
            controller={this.controller}
            close={() => this.toggleJournalDialog(null)}
            //onJournalComplete={this.state.onJournalComplete}
          />
        ) : null}

        {/* Journal dialog for Top Comparison Card */}
        {selectedGoal ? (
          <JournalDialog
            type={"reflection"}
            item={selectedGoal}
            controller={this.controller}
            close={() => this.toggleGoalJournalDialog(null)}
            onJournalComplete={this.state.onGoalJournalComplete}
          />
        ) : null}

        {selectedMenuTimeslot ? (
          <MenuEditOptionsPanel
            isPanelActive={!!selectedMenuTimeslot}
            close={() => this.toggleEditMenuOptions(null)}
            options={this.getMenuOptions(selectedMenuTimeslot)}
          />
        ) : null}
      </View>
    );
  }
}
